import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

const textAnim = (() => {
    const init = () => {
        jQuery(($) => {
            slideUpChars($);
            perWordSlideUp($);
        });
    };

    const splitText = ($el) => {
        const text = $el.text();
        let html = "";

        text.split("").forEach((char) => {
            html += `<span class="text-char">${char}</span>`;
        });

        $el.html(html);
    };

    const slideUpChars = ($) => {
        const $targets = $(
            ".text-slide-up .elementor-heading-title, .text-slide-up"
        );

        if (!$targets.length) return;

        $targets.each(function () {
            const $el = $(this);
            splitText($el);

            const chars = $el.find(".text-char");

            gsap.set(chars, {
                opacity: 0,
                y: 25,
                display: "inline-block",
                willChange: "transform, opacity",
                fontSize: "inherit",
                fontWeight: "inherit",
                lineHeight: "inherit",
                letterSpacing: "inherit",
                fontFamily: "inherit",
            });

            gsap.to(chars, {
                opacity: 1,
                y: 0,
                stagger: 0.03,
                duration: 0.6,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: $el[0],
                    start: "top 85%",
                    once: true,
                },
            });
        });
    };

    const perWordSlideUp = ($) => {
        const $targets = $(".perword-slide-up .elementor-heading-title");

        if (!$targets.length) return;

        $targets.each(function () {
            const el = this;

            requestAnimationFrame(() => {
                gsap.set(el, { opacity: 1 });

                const split = SplitText.create(el, {
                    type: "words,lines",
                    linesClass: "line",
                    autoSplit: true,
                    mask: "lines",
                    onSplit: (self) => {
                        gsap.from(self.lines, {
                            duration: 0.65,
                            yPercent: 100,
                            opacity: 0,
                            stagger: 0.1,
                            delay: 0.18,
                            ease: "expo.out",
                            scrollTrigger: {
                                trigger: el,
                                start: "top 98%",
                                once: false,
                            },
                        });
                    },
                });
            });
        });
    };

    return { init };
})();

jQuery(() => {
    try {
        textAnim.init();
    } catch (error) {
        console.error("textAnim initialization failed:", error);
    }
});
